import React, {useEffect, useState} from "react";
import "../styles/MyPageSidebar.css";
import {useNavigate} from "react-router-dom";

const MyPageSidebar = () => {
    var navigate = useNavigate();
    const [offset, setOffset] = useState(160); // 초기 위치 설정

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;
            const targetOffset = Math.max(160, scrollY + 40); // 부드럽게 이동할 목표 위치

            setOffset((prevOffset) => prevOffset + (targetOffset - prevOffset) * 0.1); // 지연 효과 적용
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <div className="mypage-sidebar">
            <ul>
                <li className="sidebar-item main">
                    <span className="sidebar-item" onClick={() => {navigate("/mypage")}}>MY 관리</span>
                    <span className="sub-title" onClick={() => {navigate("/mypage/my-info")}}>개인정보 관리</span>
                    <span className="sub-title" onClick={() => {navigate("/mypage/notification")}}>알림 관리</span>
                </li>
                <li className="sidebar-item" onClick={() => {navigate("/mypage/purchase-list")}}>구매내역</li>
                {/*<li className="sidebar-item">찜한상품</li>*/}
                <li className="sidebar-item main">
                    <span className="sidebar-item" onClick={() => {navigate("/mypage/review-list")}}>리뷰관리</span>
                    <span className="sub-title" onClick={() => {navigate("/mypage/review-available-list")}}>리뷰 가능한 상품</span>
                    <span className="sub-title" onClick={() => navigate("/mypage/review-written-list")}>내가 작성한 리뷰</span>
                </li>
                <li className="sidebar-item" onClick={() => navigate("/mypage/qna")}>Q&A관리</li>
                <li className="sidebar-item" onClick={() => navigate("/mypage/subscription")}>구독관리</li>
                <li className="sidebar-item" onClick={() => navigate("/mypage/custom-order")}>맞춤상품 신청내역</li>
            </ul>
        </div>
    );
};

export default MyPageSidebar;
